import { Skeleton } from '@buffer-mono/popcorn'
import styles from './SettingsPageSkeleton.module.css'

import type { JSX } from 'react'

export function SettingsPageSkeleton(): JSX.Element {
  return <Skeleton className={styles.skeleton} />
}
